module.exports = __webpack_public_path__ + "img/8.197cca30.png";